import React, { useEffect } from 'react';

const styles = {
  wrap: {
    position: 'fixed', bottom: 24, right: 24, zIndex: 9999,
    display: 'flex', flexDirection: 'column', gap: 10,
  },
  toast: (type) => ({
    padding: '12px 18px',
    borderRadius: 8,
    fontFamily: "'Space Mono', monospace",
    fontSize: 13,
    maxWidth: 360,
    borderLeft: `3px solid ${type === 'error' ? '#ff4d6a' : '#00ff88'}`,
    background: '#0d1117',
    color: '#e0eaf5',
    boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
    animation: 'slideIn 0.2s ease',
  }),
};

export const ToastContainer = ({ toasts, remove }) => (
  <>
    <style>{`
      @keyframes slideIn { from { opacity:0; transform:translateX(30px) } to { opacity:1; transform:translateX(0) } }
    `}</style>
    <div style={styles.wrap}>
      {toasts.map(t => (
        <Toast key={t.id} toast={t} remove={remove} />
      ))}
    </div>
  </>
);

const Toast = ({ toast, remove }) => {
  useEffect(() => {
    const timer = setTimeout(() => remove(toast.id), 4000);
    return () => clearTimeout(timer);
  }, [toast.id, remove]);

  return (
    <div style={styles.toast(toast.type)} onClick={() => remove(toast.id)}>
      {toast.type === 'error' ? '❌ ' : '✅ '}{toast.message}
    </div>
  );
};

export const useToast = () => {
  const [toasts, setToasts] = React.useState([]);
  const add = (message, type = 'success') =>
    setToasts(p => [...p, { id: Date.now(), message, type }]);
  const remove = (id) => setToasts(p => p.filter(t => t.id !== id));
  return { toasts, toast: add, remove };
};
